export default {
	default: {
		color: '#777',
		lineDash: '2,1',
		width: 1
	},
	horizontal: {
		color: null,
		lineDash: null,
		width: null
	},
	vertical: {
		color: null,
		lineDash: null,
		width: null
	}
};
